const appointmentErrors = [
    'INTERNAL_SERVER_ERROR',
    'TOKEN_NOT_VALID_OR_EXPIRED',
    'JWT_TOKEN_NOT_FOUND',
    'APPOINTMENT_NOT_FOUND',
    'APPOINTMENT_IN_THE_PAST',
    'APPOINTMENT_CANCELLED_RESCHEDULED', 
];
const isAppointmentErrorStatus = (error)=>{
    return appointmentErrors.includes(error);
};

export { appointmentErrors, isAppointmentErrorStatus };
//# sourceMappingURL=appointments.js.map
